import React from 'react';
import { useField } from 'formik';

import Summernote from './Summernote.jsx';

const FieldSummernote = (props) => {
  const [, { value }, { setTouched, setValue }] = useField(props);

  const onChange = (v) => {
    setValue(v.replace(' ', '') === '<br>' ? '' : v);
  };

  // Ensure value is always a string, never undefined
  const safeValue = value ?? '';

  return (
    <Summernote
      value={safeValue}
      onBlur={setTouched}
      onChange={onChange}
      {...props}
    />
  );
};

export default FieldSummernote;
